import { useEffect, useRef, useState } from "react"
import Flex from "../../../../components/flex"
import { reportStore } from "@/routes/apt/[apt_code]/report/report-store"
import { useParams, useSearchParams, useNavigate } from "react-router-dom"
import { langStore } from "@/stores/lang-store"
import HeaderWrapperMobile from "../header-wrapper-mobile"
import ImageBox from "@/components/image-box"
import { aptSearchStore } from "@/routes/select/apt/apt-search-store"
import { toast } from "sonner"
import { headerBundle } from "./report-header-const"
import CustomDateInput from "./custom-date-input"

const ReportHeaderMobile = ({ position = "sticky" }) => {
  const navigate = useNavigate()
  const { apt } = useParams()
  const [searchParams] = useSearchParams()
  const resource = searchParams.get("resource")
  const startDate = searchParams.get("start_date") ?? ""
  const endDate = searchParams.get("end_date") ?? ""

  const pickApt = aptSearchStore((s) => s.pickApt)
  const maxEndDate = pickApt.ended_at

  const { lang } = langStore()
  const { apiGetReport } = reportStore()

  // 드롭다운 및 로컬 상태 관리
  const [open, setOpen] = useState(false)
  const rootRef = useRef(null)
  const [dropdownTop, setDropdownTop] = useState(0)
  // 드롭다운 내부에서만 변경되는 임시 날짜 상태
  const [startDateView, setStartDateView] = useState("")
  const [endDateView, setEndDateView] = useState("")

  useEffect(() => {
    if (open) {
      if (rootRef.current) {
        const rect = rootRef.current.getBoundingClientRect()
        setDropdownTop(rect.bottom)
      }
    }
  }, [open, startDate, endDate])

  useEffect(() => {
    if (!open) return
    const onDown = (e) => {
      if (rootRef.current && rootRef.current.contains(e.target)) return
      setOpen(false)
    }
    document.addEventListener("mousedown", onDown)
    document.addEventListener("touchstart", onDown)
    return () => {
      document.removeEventListener("mousedown", onDown)
      document.removeEventListener("touchstart", onDown)
    }
  }, [open])

  const handleApplySearch = async () => {
    const nextStartDate = startDateView || startDate
    const nextEndDate = endDateView || endDate

    const loading = toast.loading("조회 중입니다...")

    try {
      await apiGetReport({
        apt,
        start_date: nextStartDate,
        end_date: nextEndDate,
        resource
      })

      toast.success("조회되었습니다.", {
        id: loading,
        duration: 400
      })

      setOpen(false)
    } catch (err) {
      toast.error("조회에 실패했습니다.", {
        id: loading
      })

      console.error(err)
    }
  }

  return (
    <HeaderWrapperMobile position={position}>
      <Flex className="items-center w-full justify-between" gap={2}>
        <div
          className="flex items-center gap-3 cursor-pointer"
          onClick={() => navigate("/select/apt")}
        >
          {/* 로고 이미지*/}
          <ImageBox
            src="/images/toicos-logo-a.png"
            className="w-8 h-8 object-contain"
            alt="Toicos Logo"
          />
          {/* 단지명 텍스트 */}
          <h1 className="font-bold text-lg text-slate-800 truncate max-w-[50vw]">
            {pickApt.apt_name}
          </h1>
        </div>

        {/* 오른쪽 영역: 돋보기 버튼 + 드롭다운 */}
        <Flex className="items-center relative mr-3" gap={3}>
          <div ref={rootRef} className="relative">
            <button
              onClick={() => setOpen((v) => !v)}
              aria-label={headerBundle.search?.[lang] ?? "Search"}
              className={`h-10 w-10 rounded-md flex items-center justify-center cursor-pointer transition-colors
                ${open ? "bg-blue-100 text-blue-600" : "bg-transparent text-gray-700"}`}
            >
              <svg
                viewBox="0 0 24 24"
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
              >
                <circle cx="11" cy="11" r="7" />
                <path d="M20 20l-3.5-3.5" />
              </svg>
            </button>

            {/* 드롭다운 패널 */}
            {open && (
              <div
                className="fixed left-0 right-0 z-10 px-4"
                style={{ top: dropdownTop + 8 }}
                onClick={(e) => e.stopPropagation()}
              >
                <div className="bg-white rounded-xl border border-gray-200 shadow-2xl p-4 w-full">
                  <div className="space-y-4">
                    <div className="grid grid-cols-2 gap-2">
                      <CustomDateInput
                        label={headerBundle.startDate[lang]}
                        value={startDateView || startDate}
                        onChange={(e) => setStartDateView(e.target.value)}
                        max={maxEndDate}
                        lang={lang}
                      />
                      <CustomDateInput
                        label={headerBundle.endDate[lang]}
                        value={endDateView || endDate}
                        max={maxEndDate}
                        onChange={(e) => setEndDateView(e.target.value)}
                        lang={lang}
                      />
                    </div>
                    <button
                      onClick={handleApplySearch}
                      className="w-full py-2.5 rounded-lg bg-blue-600 text-white font-bold text-sm hover:bg-blue-700 transition-colors shadow-md"
                    >
                      {headerBundle.search?.[lang] ?? "Search"}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </Flex>
      </Flex>
    </HeaderWrapperMobile>
  )
}

export default ReportHeaderMobile
